import React from 'react';
import Title from './Title';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Divider, Grid, Typography } from '@material-ui/core';
import { HomeTableItem } from '../../../Models/HomeTableItem';
import { Loading } from '../../../ui/Loading';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles({
  table: {},
  split: {
    display: 'flex',
    flexDirection: 'row',
    maxHeight: '100%',
    maxWidth: '100%',
    padding: 16,
  },
  cardData: {
    color: 'black',
    padding: 10,
    fontSize: '12px',
    height: '30%',
    display: 'flex',
    lineHeight: '20px',
    alignItems: 'right',
    justifyContent: 'end',
  },
});

interface ICotasCon {
  itens: any[];
  loadingCotaCon: boolean;
  data: string;
}

export default function CotasCon({ itens, loadingCotaCon, data}: ICotasCon) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Title>
        <Grid container spacing={0} justifyContent="space-between">
          <Grid item xs={8} xl={8}>
            <img
              alt="contemplado"
              src="/assets/contemplado.png"
              height="85px"
            ></img>
            <span style={{ textAlign: 'center', verticalAlign: 'center' }}>
              Cotas Contempladas
            </span>
          </Grid>
          <Grid item xs={4} xl={4}>
            <Typography className={classes.cardData}>
              {data}
            </Typography>
          </Grid>
        </Grid>
      </Title>
      <Divider style={{ margin: '0px 16px' }} />
      <div className={classes.split}>
        <TableContainer>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell align="center">Quantidade</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!loadingCotaCon &&
                itens.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {row.descricao}
                    </TableCell>
                    <TableCell align="center">{row.qtde}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          {loadingCotaCon && (
            <>
              <Skeleton height="30px" width="100%" />
              <Skeleton height="30px" width="100%" />
              <Skeleton height="30px" width="100%" />
              <Skeleton height="30px" width="100%" />
            </>
          )}
        </TableContainer>
      </div>
    </React.Fragment>
  );
}
